import React from "react";
import { Link } from "react-router-dom";
import styles from "./cta.module.css";
import { Button, Section } from "../../../../COMPONENTS/UI";
import TextReveal from "../../../../COMPONENTS/ANIMATION/TextReveal";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import { finalCta } from "../../../../CONTENT/home";

const FinalCta = () => (
  <Section tone="ink" id="talk-to-kur" labelledBy="cta-title" className={styles.cta}>
    <div className={styles.layout}>
      <Reveal className={styles.inner}>
        <TextReveal as="h2" id="cta-title" className={styles.title}>
          {finalCta.title}
        </TextReveal>
        <Button href={finalCta.primary.href} variant="primary">
          {finalCta.primary.label}
        </Button>
      </Reveal>
      <Reveal delay={0.15} as="nav" className={styles.paths} aria-label="Audience paths">
        <p className={styles.pathsLabel}>Or start with your path</p>
        {finalCta.paths.map((p) => (
          <Link key={p.href} to={p.href} className={styles.path}>
            <span className={styles.pathLabel}>{p.label}</span>
            <span className={styles.pathText}>{p.text}</span>
            <span className={styles.pathArrow} aria-hidden="true">
              →
            </span>
          </Link>
        ))}
      </Reveal>
    </div>
  </Section>
);

export default FinalCta;
